module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"acepto_politica":"Acepto la política de protección de datos","obligatoria":"Es obligatorio aceptar la política de protección de datos","hint_web":"Puedes leer la política de privacidad desde el enlace en el menú inferior","hint_movil":"Puedes leer la política de privacidad desde el enlace en el menú lateral"}}')
  delete Component.options._Ctor
}
